import { render, staticRenderFns } from "./GroundPage.vue?vue&type=template&id=394dde5c&scoped=true"
import script from "./GroundPage.vue?vue&type=script&lang=js"
export * from "./GroundPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394dde5c",
  null
  
)

export default component.exports